import { HtmlPageMetaContextProps } from '~/components/HtmlPageMeta/HtmlPageMetaContextProps'
import GetFeaturedOrganizersResponseInterface
  from '~/modules/Organizers/Application/GetFeaturedOrganizers/GetFeaturedOrganizersResponseInterface'
import { ApplicationTrophyDto } from '~/modules/Products/Application/Dtos/ApplicationTrophyDto'

export interface HomePageViewModel {
  htmlPageMetaContextProps: HtmlPageMetaContextProps
  organizers: GetFeaturedOrganizersResponseInterface[]
  featuredAwards?: ApplicationTrophyDto[]
  page: {
    number: number
    size: number
  }
}

export function fromHomePagePropsToViewModel (props: HomePageViewModel): HomePageViewModel {
  return {
    htmlPageMetaContextProps: props.htmlPageMetaContextProps,
    organizers: props.organizers,
    featuredAwards: props.featuredAwards ?? [],
    page: props.page,
  }
}
